import { useEffect } from 'react';

export function ItemNavigation({ onNavigate, currentIndex, totalItems }) {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'ArrowLeft' && currentIndex > 0) {
        e.preventDefault(); // stop the table scroll
        onNavigate('prev');
      }
      if (e.key === 'ArrowRight' && currentIndex < totalItems - 1) {
        e.preventDefault(); // stop the table scroll
        onNavigate('next');
      }
    }
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onNavigate, currentIndex, totalItems]);

  const isFirstItem = currentIndex === 0;
  const isLastItem = currentIndex === totalItems - 1;

  return (
    <div className="flex justify-between mt-6">
      <button 
        onClick={() => !isFirstItem && onNavigate('prev')} 
        className={`px-3 py-1 rounded ${isFirstItem ? 'bg-[var(--button3-bg-color)] text-[var(--text-color)] cursor-not-allowed' : 'bg-[var(--button-bg-color)] text-[var(--text-color)] hover:bg-[var(--button3-bg-color)]'}`}
        disabled={isFirstItem}
      >
        ← Prev
      </button>
      <button 
        onClick={() => !isLastItem && onNavigate('next')} 
        className={`px-3 py-1 rounded ${isLastItem ? 'bg-[var(--button3-bg-color)] text-[var(--text-color)] cursor-not-allowed' : 'bg-[var(--button-bg-color)] text-[var(--text-color)] hover:bg-[var(--button3-bg-color)]'}`}
        disabled={isLastItem}
      >
        Next →
      </button>
    </div>
  );
}